var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ThemeVBtn',_vm._b({attrs:{"width":_vm.width,"height":_vm.height,"min-width":"40px"},on:{"click":(e) => _vm.$emit('click', e)}},'ThemeVBtn',_vm.$attrs,false),[_c('div',{staticClass:"flex items-center justify-center p-2px"},[_c('v-icon',{staticClass:"!text-inherit",attrs:{"size":"20"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }